module.exports = __webpack_public_path__ + "182f27335026b61039e52c924c32c86f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thesafezone/office.jpg
// module id = 338
// module chunks = 1